export const SUBMISSION_CONFIRMATION = process.env.EMAIL_TEMPLATE_SUBMISSION_CONFIRMATION ||  "got-submission-confirmation";